import './typeahead';
// import 'jquery-typeahead';

const $ = window.jQuery;

class SmartContact {
  constructor(searchContainer, keywords, offices) {
    this.searchContainer = searchContainer;
    this.keywords = keywords;
    this.offices = offices;
  }

  init() {
    this.main = $('.main');
    this.autoComplete = this.searchContainer.find('#smart-contact-auto-complete');
    this.clearButton = this.searchContainer.find('.btn-clear');

    this.officeSelector = this.searchContainer.find('#office-select');
    this.officeSelector.change(e => this.selectOffice(e));

    this.findOfficeResults = this.searchContainer.find('#single-office-result');
    this.multipleOfficeResultsAccordion = this.searchContainer.find('#multiple-office-results');

    this.formWrapper = this.main.find('#form-wrapper');

    this.mainContact = $('.main-contact');
    this.mainContactFormContainer = this.mainContact.find('.form-container');
    this.mainOfficeIdField = this.formWrapper.find('input[type="hidden"][value="{{gp-groot-office-id}}"]');
    this.mainOfficeTitleField = this.formWrapper.find('input[type="hidden"][value="{{gp-groot-office-title}}"]');

    this.officeResults = $('.office-results');
    this.officeResultsItems = $('.card-office', this.officeResults);
    
    this.clearButton.on('click', () => this.onClear());

    this.initializeAutoComplete();
    this.inititializeOfficeId();
    this.handleMultipleOfficeResultsAccordionOpenEvent();

    this.officeSelector.change();
  }

  selectOffice(e) {
    const selector = $(e.currentTarget);
    const selectedOfficeId = selector.children(':selected').val();

    if (selectedOfficeId) {
      this.showOffice(selectedOfficeId);
    } else {
      this.inititializeOfficeId();
      this.findOfficeResults.html('');
    }

    this.hideResults();
  }

  showOffice(id) {
    const office = this.findOffice(id);

    this.setOfficeIdAndTitleInForm(id, office.fields.title);

    const address = office.fields.address ? `${office.fields.address}, <br />` : '';
    const poBox = office.fields.pobox ? `Postbus ${office.fields.pobox}, <br />` : '';

    const phone = office.fields.phone
      ? `<a href="tel:${office.fields.phone}" class="office-phone">
        <i class="fas fa-phone"></i> Bel ${office.fields.phone}
      </a>` : '';

    const portal = office.fields.portal_url
      ? `<a href="${office.fields.portal_url}" class="office-portal">
        <i class="fas fa-user-circle"></i> ${office.fields.portal}
      </a>` : '';

    const photo = office.image
      ? `<img src="${office.image}" alt="${office.fields.title}" class="office-image">` : '';

    const html = `
      <div class="office">
        <h4>${office.fields.title}</h4>
        <div class="row row-address">
          <div class="col-12 col-md-6">
              <address>
                  ${address}
                  ${office.fields.postal_code} ${office.fields.city}
              </address>
          </div>
          <div class="col-12 col-md-6">
              <address>
                  ${poBox}
                  ${office.fields.pobox_postalcode} ${office.fields.pobox_city}
              </address>
          </div>
        </div>

        <a href="https://maps.google.com/?q=${office.fields.maps_location}" class="office-location" target="_blank">
            <i class="fas fa-map-marker-alt"></i> Bekijk locatie op Google Maps <i class="fas fa-arrow-up"></i>
        </a>

        ${phone}

        ${portal}

        ${photo}
      </div>
    `;

    this.findOfficeResults.html(html);
  }

  findOffice(id) {
    for (let x = 0; x < this.offices.length; x += 1) {
      if (this.offices[x].ID === parseInt(id, 0)) {
        return this.offices[x];
      }
    }

    return null;
  }

  initializeAutoComplete() {
    if (this.autoComplete.length) {
      this.autoComplete.typeahead({
        theme: 'bootstrap4',
        source: this.keywords,
        afterSelect: (keyword) => { this.onKeywordSelect(keyword); },
        items: 12,
      });

      const defaultKeyword = this.autoComplete.data('default-keyword');

      if (defaultKeyword) {
        this.autoComplete.val(defaultKeyword);
        this.onKeywordSelect({ name: defaultKeyword });
      }
    }
  }

  inititializeOfficeId() {
    const officeId = this.mainContact.length ? this.mainContact.data('office-id') : '';
    const officeTitle = this.mainContact.length ? this.mainContact.data('office-title') : '';

    this.setOfficeIdAndTitleInForm(officeId, officeTitle);
  }

  setOfficeIdAndTitleInForm(id, title) {
    this.mainOfficeIdField.val(`gp-groot-office-id:${id}`);
    this.mainOfficeTitleField.val(`gp-groot-office-title:${title}`);
  }

  onKeywordSelect(keywordObject) {
    let matchingOffices = null;
    this.clearButton.addClass('show');

    const keyword = keywordObject.name;

    if (keywordObject.productUrl) {
      window.open(keywordObject.productUrl, '_blank');
    }

    if (keyword) {
      const searchFor = `;${keyword};`;
      matchingOffices = $(`[data-keywords*='${searchFor}']`, this.officeResults);
    }

    if (matchingOffices && matchingOffices.length) {
      this.officeResultsItems.hide();
      matchingOffices.show();
      this.officeResults.show();

      this.findOfficeResults.html('');

      if (matchingOffices.length === 1) {
        const firstItem = $(matchingOffices[0]).find('button');
        
        if (firstItem && firstItem.attr('aria-expanded') === 'false') {
          firstItem.trigger('click');
        }
      }
    } else {
      this.officeResults.hide();
      this.hideResults();
    }
  }

  onClear() {
    this.clearButton.removeClass('show');
    this.autoComplete.val('');

    this.officeResults.hide();
  }

  showMainContact() {
    this.inititializeOfficeId();
  }

  hideResults() {
    this.officeResults.hide();
  }

  showResults() {
    this.officeResultsItems.show();
    this.officeResults.show();
  }

  handleMultipleOfficeResultsAccordionOpenEvent() {
    this.multipleOfficeResultsAccordion.on('shown.bs.collapse', () => {
      const btn = this.multipleOfficeResultsAccordion.find('button[aria-expanded=true]');

      if (btn) {
        const officeId = btn.data('office-id');
        const officeTitle = btn.data('office-title');

        if (officeId) {
          this.setOfficeIdAndTitleInForm(officeId, officeTitle);
        }
      }
    });
  }
}

$(document).ready(() => {
  const searchContainer = $('.col-main-office');
  const keywords = global.officeKeywords;
  const { offices } = global;

  new SmartContact(searchContainer, keywords, offices).init();
});
